import React from 'react';
import logo from './logo.svg';
import './App.css';
import Vragenlijst from './Vragenlijst';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Vragenlijst/>
      </header>
    </div>
  );
}

export default App;
